export default "__VITE_ASSET__nKs9uL3j__"